<template>
  <div>
      <a
          href="javascript:;"
          data-toggle="modal"
          id="modal-success"
          style="display: none"
          data-target="#success-modal-preview"
          class="button inline-block bg-theme-1 text-white"
      ></a>
    <div id="success-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <CheckCircleIcon
              class="w-16 h-16 text-theme-9 mx-auto mt-3"
          />
          <div class="text-gray-600 mt-2">
            {{modalText}}
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">{{modalText}}</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        Choose your Protected Matters Search Tool result .pdf file for converting
      </h2>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: File Type Validation -->
        <div class="intro-y box">
          <div
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">Upload your Protected Matters Search Tool result .pdf file</h2>
          </div>

          <div id="file-type-validation" class="p-5">
            <div class="preview">
              <VueDropzone
                id="dropzone-validation"
                ref="MyDropzone"
                :use-custom-slot="true"
                :options="{
                  url: 'https://httpbin.org/post',
                  acceptedFiles: 'application/pdf',
                  maxFiles: 1,
                  addRemoveLinks: true
                }"
                class="dropzone font-roboto border-gray-200 border-dashed text-gray-800 hover:bg-transparent"
                @vdropzone-file-added="validateFileEvent"
                @vdropzone-error="dropzoneError"
                @vdropzone-removed-file="removeEvent"
              >
                <div class="text-lg font-medium">
                  Drop files here or click here to upload.
                </div>
                <div class="text-gray-600"></div>
              </VueDropzone>
            </div>
          </div>
          <div class="text-center">
            <button
                type="button"
                class="button inline-block bg-theme-1 text-white"
                :disabled="file === null"
                @click="createFile"
            >
              Convert
            </button>
          </div>
        </div>
        <!-- END: File Type Validation -->
      </div>
      <div class="intro-y col-span-12 lg:col-span-6 box">
        <div class="intro-y box">
          <div
            class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">
              How to use
            </h2>
          </div>

          <div class="accordion px-5 py-1">
            <div
              class="accordion__pane active border-b border-gray-200 dark:border-dark-5 py-4"
            >
              <!--            <a-->
              <!--              href="javascript:;"-->
              <!--              class="accordion__pane__toggle font-medium block"-->
              <!--              >OpenSSL Essentials: Working with SSL Certificates, Private-->
              <!--              Keys</a-->
              <!--            >-->
              <div
                class="accordion__pane__content mt-3 text-gray-700 dark:text-gray-600 leading-relaxed"
              >
                • Upload PMST result .pdf <br />
                • Submit payment details - payments made via secure STRIPE payment platform <br />
                • Confirm conversion of pdf to editable excel file <br /> <br />
                An email with the editable excel file and a tax invoice will be sent
                to your registered email address.
                <br />
                <br />To get PMST results for your study area follow this link:
                <a href="https://environment.gov.au/epbc/protected-matters-search-tool" style="text-decoration: underline; color: blue">Protected Matters Search Tool</a>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="intro-y col-span-12 lg:col-span-6 box">
        <!-- BEGIN: Basic Table -->
        <div class="intro-y box">
          <div
              class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">Recent activity</h2>
          </div>
          <div id="basic-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                  <tr>
                    <th
                        class="border-b-2 dark:border-dark-5 whitespace-no-wrap"
                    >
                      Email
                    </th>
                    <th
                        class="border-b-2 dark:border-dark-5 whitespace-no-wrap"
                    >
                      Filename
                    </th>
                    <th
                        class="border-b-2 dark:border-dark-5 whitespace-no-wrap"
                    >
                      Date
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(order, orderKey) in orders" :key="orderKey">
                    <td class="border-b dark:border-dark-5">{{ order.email_send }}</td>
                    <td class="border-b dark:border-dark-5">{{ order.filename }}</td>
                    <td class="border-b dark:border-dark-5">{{ order.created_at }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Basic Table -->
      </div>
      <div class="intro-y col-span-12 lg:col-span-6 box">
        <div class="intro-y box lg:mt-5">
          <div
              class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
          >
            <h2 class="font-medium text-base mr-auto">Personal Information</h2>
          </div>
          <div class="p-5">
            <div class="grid grid-cols-12 gap-5">
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Email</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="Email"
                      v-model="user.email"
                  />
                </div>
                <div class="mt-3">
                  <label>First name</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="first name"
                      v-model="user.first_name"
                  />
                </div>
                <div class="mt-3">
                  <label>Old password</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="old password"
                      v-model="user.old_pass"
                  />
                </div>
                <div class="mt-3">
                  <label>New password</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="new password"
                      v-model="user.new_pass"
                  />
                </div>
              </div>
              <div class="col-span-12 xl:col-span-6">
                <div>
                  <label>Address</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="address"
                      v-model="user.address"
                  />
                </div>
                <div class="mt-3">
                  <label>Last name</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="last name"
                      v-model="user.last_name"
                  />
                </div>
                <div class="mt-3">
                  <label>Company</label>
                  <input
                      type="text"
                      class="input w-full border mt-2"
                      placeholder="company"
                      v-model="user.company"
                  />
                </div>
              </div>
            </div>
            <div class="flex justify-end mt-4">
              <button
                  type="button"
                  class="button w-20 bg-theme-1 text-white ml-auto"
                  @click="updateProfile"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";
import AuthService from '../services/Auth';
const authService = new AuthService();

export default {
  components: {
    VueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      file: null,
      modalText: "",
      orders: [
        {
          email_send: null,
          filename: null,
          created_at: null
        }
      ],
      user: {
        email: "",
        last_name: "",
        first_name: "",
        company: "",
        address: "",
        old_pass: "",
        new_pass: ""
      },
    };
  },
  mounted() {
    this.setUser()
    this.getOrdersUser()
  },
  methods: {
    setUser() {
      this.user = authService.getUser()
      console.log(this.user)
    },
    // eslint-disable-next-line no-unused-vars
    validateFileEvent(file) {
      if (this.$refs.MyDropzone.getAcceptedFiles().length > 0) {
        this.$refs.MyDropzone.removeFile(file);
        return;
      }

      let formDataTo = new FormData();
      formDataTo.append("file", file);

      axios
        .put("check/pdf/", formDataTo, {
          headers: {
            "Content-Disposition":
              "attachment; filename=" + file.upload.filename
          }
        })
        .then(response => {
          // console.log(response);
          if (response.data.verification_status === "success") {
            this.file = file;
          } else {
            this.modalText = "Error: Uploaded file is not compatible. Please upload an original PMST output .pdf file"
            document.getElementById("show-modal").click()
            this.$refs.MyDropzone.removeFile(file);
          }
        })
        .catch(err => {
          // console.log(err);
          this.error = err;
        });
    },
    updateProfile() {
      axios
          .put("user/update/", this.user, )
          .then(response => {
            if (response.data.error === 1 && response.data.message === "mailuniq") {
              this.modalText = "Error: The email provided is already registered. Please use another address."
              document.getElementById("show-modal").click()
            } else {
              authService.setUser(response.data)
              if (this.user.old_pass !== "" && this.user.new_pass) {
                axios.post("change-password/", {
                  old_password: this.user.old_pass,
                  new_password: this.user.new_pass
                }).then( res => {
                  console.log(res.data)
                  if (res.data.old_password) {
                    this.modalText = "Err. Old password wrong"
                    document.getElementById("show-modal").click()
                  } else {
                    this.modalText = "Password success changed"
                    document.getElementById("modal-success").click()
                  }
                  this.user.old_pass = "";
                  this.user.new_pass = "";
                }).catch(err => {
                  this.error = err;
                });
              }
            }
          })
          .catch(err => {
            this.error = err;
          });
    },
    getOrdersUser() {
      let self = this
      axios
          .get("user/orders/")
          .then(response => {
            self.orders = response.data
            console.log(self.orders)
            // response.data.forEach(element => console.log(element));
          })
          .catch(err => {
            self.error = err;
          });

      console.log(self.orders)
    },
    createFile() {
      let formDataTo = new FormData();
      formDataTo.append("file", this.file);

      axios
        .put("file/create/", formDataTo, {
          headers: {
            "Content-Disposition":
              "attachment; filename=" + this.file.upload.filename
          }
        })
        .then(response => {
          if (response.data.status && response.data.status === "created") {
            // console.log(response.data);
            if (authService.isAdminRole()) {
              axios.post("free/convert/", {
                file_id: response.data.file.id
              }).then(response => {
                if (response.data.status === "OK") {
                  this.$router.push("/success");
                }
              });
            } else {
              this.$router.push("/checkout/" + response.data.file.id);
            }
          } else {
            alert("Something go wrong. Contact with support");
          }
        })
        .catch(err => {
          // console.log(err);
          this.error = err;
        });
    },
    dropzoneError(err) {
      // console.log(err);
      if (!err.type.includes("pdf")) {
        alert("Error! Files of this type are not accepted");
      }
    },
    // eslint-disable-next-line no-unused-vars
    removeEvent(file) {
      // console.log(file);
      this.file = null;
    }
  }
};
</script>
<style>
.button.inline-block.bg-theme-1.text-white{
  margin-bottom: 20px;
}
</style>
